import React from 'react';
import classnames from 'classnames';
import Timestamp from '../../../../Timestamp';
import { getDeviationTitle } from '../../../../DeviationViews/_helpers';
import { getThumbGlobalClassNames } from '../../helpers';
var JournalThumbHtmlView = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height;
    return (React.createElement("div", { style: { width: width, height: height }, className: classnames('daeditor-freeform-root', getThumbGlobalClassNames(deviation)) },
        React.createElement("div", { className: "daeditor-freeform-header" },
            React.createElement("span", { className: "daeditor-freeform-title" }, getDeviationTitle(deviation))),
        React.createElement("div", { className: "daeditor-freeform-body" },
            React.createElement("div", { className: "daeditor-freeform-date" },
                React.createElement(Timestamp, { timestamp: deviation.publishedTime })),
            React.createElement("div", { className: "daeditor-freeform-text" }, deviation.textContent && deviation.textContent.excerpt))));
};
JournalThumbHtmlView.displayName = 'JournalThumbHtmlView';
export default JournalThumbHtmlView;
//# sourceMappingURL=JournalHtml.js.map